import "../../../css/Buttons/StatusButton.css";

const StatusButton = ({ type, color }) => {
  return (
      <div className={`Status-Button-Container ${color}`}>
          <div className="Status-Indicator" />
      <div className="AML-Text-Input">{type}</div>
    </div>
  );
};

export default StatusButton;
